import { jsx as m } from "react/jsx-runtime";
import i from "./HighlightOffRounded.mjs";
import { StyledChip as e } from "./styles61.mjs";
import { CHIP_VARIANT_MAPPING as a } from "./constants5.mjs";
const l = ({
  variant: r = "primary",
  color: o = "primary",
  hasShadow: p,
  ...t
}) => /* @__PURE__ */ m(
  e,
  {
    deleteIcon: /* @__PURE__ */ m(i, {}),
    color: o,
    ...a[r],
    $variant: r,
    $color: o,
    $hasShadow: p,
    ...t
  }
);
export {
  l as Chip
};
//# sourceMappingURL=index90.mjs.map
